export const overview = {
  firstName: "Test",
  lastName: "McTesty",
  gender: "Male",
  dateOfBirth: "1988-08-29",
  inPracticeSinceYear: "2006",
  inPracticeSinceDate: "2019-09-01",
  specialtyCodes: ["PO", "OR", "OR", "OR", "OR", "GD", "PO", "OR", "GD"],
  professionalSuffixes: ["MD", "MD"],
  nationalProviderIdentifier: "1111111111",
  npiUnavailable: true,
  state: "ACTIVE",
  yearsOfExperience: "5",
  displayOnSite: "true",
  email: "testmc@test.com",
  middleName: "",
};

export const providerLanguages = [
  { displayId: "SDCBYUTS34657398", name: "Hindi" },
  { displayId: "SDCBYUTS97054372", name: "Dutch" },
  { displayId: "SDCBYUTS39545792", name: "Kannada" },
  { displayId: "SDCBYUTS80385186", name: "Tamil" },
];

export const speciality = [
  {
    displayId: "SDCBYUTS34657398",
    specialtyName: "Periodontics",
    instituteName: "Test Institution 1",
    year: "2021",
    isValid: "true",
  },
  {
    displayId: "SDCBYUTS97054372",
    specialtyName: "Orthodontics",
    instituteName: "Test Institution 2",
    year: "2022",
    isValid: "true",
  },
  {
    displayId: "SDCBYUTS39545792",
    specialtyName: "General Dentistry",
    instituteName: "",
    year: "2023",
    isValid: "true",
  },
];

export const GENERAL_DENTISTRY_LABEL = "General Dentistry";
